import { render, staticRenderFns } from "./AttrEditScore.vue?vue&type=template&id=adb14c4a&scoped=true&"
import script from "./AttrEditScore.vue?vue&type=script&lang=js&"
export * from "./AttrEditScore.vue?vue&type=script&lang=js&"
import style0 from "./AttrEditScore.vue?vue&type=style&index=0&id=adb14c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb14c4a",
  null
  
)

export default component.exports